import { camelCaseToKebab } from '../../utils/helpers';
import { GasModal } from './gas-modal.interface';

export function getStyles(modalStyle: GasModal.ModalStyle, style: string): Record<string, string> {
  return Object.keys(modalStyle)
    .filter(key => key.toLowerCase().includes(style))
    .map(key => {
      return mapStyleField(modalStyle, key);
    })
    .reduce((acc, val) => { return {...acc, ...val}; }, {});
}

function mapStyleField(modalStyle: GasModal.ModalStyle ,key: string): Record<string, string> {
  const resultObject = {};

  resultObject[camelCaseToKebab(key)] =
    typeof modalStyle[key] === 'string'
      ? modalStyle[key]
      : `${modalStyle[key]}px`;

  return resultObject;
}
